import React from "react";
import {
    Grid,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box,
    Typography
} from "@mui/material";

const ViewUserDialog = ({ open, handleClose, user }) => {
    const handleCancel = () => {
        handleClose(); // Close the dialog
        console.log("close dialog");
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
            sx={{
                "& .MuiDialog-paper": {
                    borderRadius: "12px",
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                },
            }}
        >
            <DialogTitle
                sx={{
                    background: "linear-gradient(45deg, #027BFE,rgb(158, 79, 249))",
                    color: "white",
                    textAlign: "center",
                    fontSize: "1rem",
                    fontWeight: "bold",
                    py: 2,
                }}
            >
                View User Details
            </DialogTitle>


            <DialogContent
                sx={{
                    p: 4,
                    maxHeight: "500px",
                    overflowY: "auto",
                    "&::-webkit-scrollbar": { width: "6px" },
                    "&::-webkit-scrollbar-thumb": { background: "#027BFE", borderRadius: "10px" },
                }}
            >
                <Grid container spacing={3} mt={2}> {/* Increased spacing */}
                    {[
                        { label: "CP ID", value: user?.userid },
                        { label: "Parent ID", value: user?.parentId },
                        { label: "Name", value: `${user?.firstName || ""} ${user?.middleName || ""} ${user?.lastName || ""}` },
                        { label: "Business Name", value: user?.bussinessName },
                        { label: "Mobile Number", value: user?.mobileNumber },
                        { label: "DOB", value: user?.dob, type: "date" },
                        { label: "Wallet Balance", value: user?.walletBalance || 0 },
                        { label: "Status", value: user?.status },
                        { label: "Category", value: user?.category },
                        { label: "Commission/Surcharge Type", value: user?.comm_sur_type },
                        { label: "Percentage", value: user?.percentage }
                    ].map((field, index) => (
                        <Grid item xs={12} md={6} key={index}>
                            <Typography
                                variant="subtitle2"
                                sx={{ fontWeight: "bold", color: "#757575", mb: 0.5 }} // Grey color
                            >
                                {field.label}
                            </Typography>
                            <TextField
                                type={field.type || "text"}
                                value={field.value || ""}
                                fullWidth
                                InputProps={{ readOnly: true }}
                                sx={{
                                    backgroundColor: "#F8F9FA",
                                    borderRadius: "8px",
                                    height: "45px",
                                    "& .MuiInputBase-input": {
                                        color: "#333"
                                    }
                                }}
                            />
                        </Grid>
                    ))}
                </Grid>

                {/* Uploaded Agreement Section */}
                <Box mt={3} p={2} sx={{ border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#fafafa" }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                        Uploaded Agreement
                    </Typography>
                    <Box
                        sx={{
                            marginTop: 1,
                            textAlign: "center",
                            padding: 2,
                            backgroundColor: "#f4f4f4",
                            borderRadius: "5px"
                        }}
                    >
                        <Typography variant="body2">No file uploaded</Typography>
                    </Box>
                </Box>
            </DialogContent>

            <DialogActions sx={{ justifyContent: "center", paddingBottom: 2 }}>
                <Button variant="contained" onClick={handleCancel} sx={{ backgroundColor: "#3f51b5", color: "#fff" }}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ViewUserDialog;
